import guangdong from "./province/guangdong";
import hk from "./province/hk";
import guizhou from "./province/guizhou";
import guangxi from "./province/guangxi";
import jiagnxi from "./province/jiangxi";
import hunan from "./province/hunan";
import hubei from "./province/hubei";
import anhui from "./province/anhui";
import fujian from "./province/fujian";
import hainan from "./province/hainan";
import chongqing from "./province/chongqing";
import jiangsu from "./province/jiangsu";
import zhejiang from "./province/zhejiang";
import shanghai from "./province/shanghai";
import china from "./province/china"
//var city = [guangdong, hk, guizhou,guangxi,jiagnxi,hunan,hubei,chongqing,anhui,fujian,hainan,jiangsu,zhejiang,shanghai];
var city=china;
export default city;



// WEBPACK FOOTER //
// ./src/util/city.js